import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
// import CardActions from '@material-ui/core/CardActions'
import Grid from '@material-ui/core/Grid'
import CustomButton from '../custom-material/button/Button'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import HelpIcon from '@material-ui/icons/Help'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@material-ui/icons/Cancel'
import EmptyStateComponent from '../common/empty-state/EmptyStateComponent'
import RequestEmailEditDialogComponent from './RequestEmailEditDialogComponent'
import RequestEmailConfirmDialogComponent from './RequestEmailConfirmDialogComponent'
// import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { contactValidState } from '../../libs/validators'

const styles = theme => ({
  contactCard: {
    margin: 16
  },
  contactCardHeader: {
    backgroundColor: '#e1ecf8'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 22
  },
  titleButtonContainer: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  editCancelButton: {
    marginRight: 8,
    backgroundColor: '#666666',
    color: 'white',
    '&:hover': {
      backgroundColor: '#515151'
    }
  },
  contactLabel: {
    color: '#003368',
    fontWeight: 600
  },
  contactInput: {
    fontSize: 15,
    border: '1px solid rgba(0, 0, 0, 0.42)',
    borderBottom: 0,
    borderRadius: 2
  },
  inputText: {
    paddingLeft: 3
  },
  contactInputDisabled: {
    color: 'rgb(84, 84, 84)',
    cursor: 'text',
    fontSize: 15,
    border: 0,
    paddingLeft: 0
  },
  contactCardFooter: {
    padding: '16px 24px',
    marginTop: 16
  },
  requestEmailEdit: {
    position: 'absolute',
    top: -8,
    right: -148,
    height: 32,
    width: 140
  },
  leadContactGrid: {
    paddingTop: '0px !important'
  },
  leadContact: {
    margin: 0,
    cursor: 'text'
  },
  leadContactLabel: {
    fontSize: 13.5,
    color: theme.palette.primary.main
  },
  leadContactHelp: {
    color: '#00ACEF',
    fontSize: 17,
    marginLeft: 2,
    marginRight: 6
  },
  leadContactCheckbox: {
    padding: 5,
    cursor: 'default'
  },
  checkboxIcon: {
    width: 20,
    height: 20
  },
  privacyStatement: {
    margin: 0,
    fontSize: 13.5
  },
  privacyLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    textDecoration: 'none'
  },
  tooltip: {
    opacity: '1.0 !important'
  }
})

class ContactComponent extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      requestEmailEditOpen: false,
      requestEmailConfirmOpen: false,
      newEmailAddress: ''
    }
    this.openRequestEmailEdit = () => this.setState({requestEmailEditOpen: true})
    this.closeRequestEmailEdit = () => this.setState({requestEmailEditOpen: false})
    this.closeRequestEmailConfirm = () => this.setState({requestEmailConfirmOpen: false})
    this.changeNewEmailAddress = event => this.setState({newEmailAddress: event.target.value})
    this.handleRequestEmailEdit = (oldEmail, newEmail) => {
      this.props.requestEmailEdit(oldEmail, newEmail)
      this.setState({requestEmailEditOpen: false, requestEmailConfirmOpen: true})
    }
  }
  render () {
    const { classes, contact, editing, profileInfoChanged, toggleEditMode, saveContact, updateContact, resetContact } = this.props
    const { requestEmailEditOpen, requestEmailConfirmOpen, newEmailAddress } = this.state
    const validState = contactValidState(contact)
    return (
      <Card className={classes.contactCard}>
        <CardHeader className={classes.contactCardHeader}
          title={
            <div className={classes.title}>
              <span>Profile Information</span>
              {isEmpty(contact)
                ? null
                : <div className={classes.titleButtonContainer}>
                  {editing
                    ? <CustomButton
                      className={classes.editCancelButton}
                      style={{width: 90}}
                      onClick={() => {
                        if (toggleEditMode) toggleEditMode()
                        resetContact()
                      }}
                      size='small'
                      variant='contained'
                    >
                      <React.Fragment>
                        <CancelIcon />
                        <span style={{marginLeft: 5, marginRight: 5}}>{toggleEditMode ? 'Cancel' : 'Reset'}</span>
                      </React.Fragment>
                    </CustomButton>
                    : null
                  }
                  <CustomButton
                    disabled={editing && (!profileInfoChanged || !validState.isValid)}
                    style={{width: 160}}
                    onClick={editing ? () => { if (toggleEditMode) toggleEditMode(); saveContact() } : toggleEditMode}
                    size='small'
                    color='secondary'
                    variant='contained'
                  >
                    <React.Fragment>
                      {editing ? <SaveIcon /> : <EditIcon />}
                      <span style={{marginLeft: 5}}>{editing ? 'Save Your Profile' : 'Edit Your Profile'}</span>
                    </React.Fragment>
                  </CustomButton>
                </div>
              }
            </div>
          }
        />
        <CardContent>
          {isEmpty(contact)
            ? <EmptyStateComponent title='Contact your Account Manager to manage your User Profile' /> // @TODO - empty state
            : <Grid container className={classes.contactGrid} spacing={2}>
              <Grid item xs={5}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      id='firstName'
                      label='First Name:'
                      value={contact.firstName || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.firstName}
                      onChange={updateContact}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='lastName'
                      label='Last Name:'
                      value={contact.lastName || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.lastName}
                      onChange={updateContact}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='jobTitle'
                      label='Job Title:'
                      value={contact.jobTitle || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.jobTitle}
                      onChange={updateContact}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='officePhone'
                      label='Office Phone:'
                      value={contact.officePhone || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.officePhone}
                      onChange={updateContact}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='country'
                      label='Country:'
                      value={contact.country || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.country}
                      onChange={updateContact}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      id='emailAddress'
                      label={
                        <div>
                          <span>Email Address:</span>
                          <CustomButton className={classes.requestEmailEdit} onClick={this.openRequestEmailEdit} size='small'  variant='contained' color='secondary'>Request Email Edit</CustomButton>
                        </div>
                      }
                      value={contact.emailAddress || ''}
                      InputProps={{disableUnderline: true, disabled: true, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='company'
                      label='Company:'
                      value={contact.company || ''}
                      InputProps={{disableUnderline: true, disabled: true, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.company}
                    />
                  </Grid>
                  <Grid style={{marginTop: editing ? 2 : 0}} item xs={12}>
                    <TextField
                      id='department'
                      label='Department:'
                      value={contact.department || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      required
                      error={!!validState.department}
                      onChange={updateContact}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id='mobilePhone'
                      label='Mobile Phone:'
                      value={contact.mobilePhone || ''}
                      InputProps={{disableUnderline: !editing, disabled: !editing, classes: {root: classes.contactInput, input: classes.inputText, disabled: classes.contactInputDisabled}}}
                      InputLabelProps={{shrink: true, classes: {shrink: classes.contactLabel}}}
                      fullWidth
                      onChange={updateContact}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid className={classes.leadContactGrid} item xs={2}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      classes={{root: classes.leadContact, label: classes.leadContactLabel}}
                      control={
                        <Checkbox
                          className={classes.leadContactCheckbox}
                          color='secondary'
                          name='leadContact'
                          checkedIcon={<img className={classes.checkboxIcon} src='/icons/CheckedBox.svg' alt='checked box' />}
                          icon={<img className={classes.checkboxIcon} src='/icons/UncheckedBox.svg' alt='unchecked box' />}
                          checked={contact.isLeadContact}
                          disableRipple
                        />
                      }
                      label={
                        <span style={{display: 'flex', cursor: 'default'}}>
                          Lead Contact
                          <Tooltip
                            classes={{popper: classes.tooltip}}
                            title={`The "Lead Contact" on your account is IPD Analytics' main point of contact for account management purposes.`}
                          >
                            <HelpIcon className={classes.leadContactHelp} />
                          </Tooltip>
                        </span>
                      }
                      labelPlacement='end'
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          }
          {requestEmailEditOpen
            ? <RequestEmailEditDialogComponent
              dialogOpen={requestEmailEditOpen}
              contact={contact}
              newEmailAddress={newEmailAddress}
              handleChangeNewEmail={this.changeNewEmailAddress}
              handleCloseDialog={this.closeRequestEmailEdit}
              requestEmailEdit={this.handleRequestEmailEdit}
            />
            : null
          }
          {requestEmailConfirmOpen
            ? <RequestEmailConfirmDialogComponent
              dialogOpen={requestEmailConfirmOpen}
              handleCloseDialog={this.closeRequestEmailConfirm}
            />
            : null
          }
        </CardContent>
        {/* <CardActions className={classes.contactCardFooter}>
          <span className={classes.privacyStatement}>IPD Analytics cares about your <Link className={classes.privacyLink} to='/'>privacy</Link>.</span>
        </CardActions> */}
      </Card>
    )
  }
}

ContactComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  contact: PropTypes.object,
  editing: PropTypes.bool,
  toggleEditMode: PropTypes.func,
  saveContact: PropTypes.func.isRequired,
  updateContact: PropTypes.func.isRequired,
  resetContact: PropTypes.func.isRequired,
  requestEmailEdit: PropTypes.func.isRequired
}

export default withStyles(styles)(ContactComponent)
